import React from 'react'

const ProcessStep = React.lazy(() => import('pages/ProcessStep/pages/ProcessStepPage'));
const ProcessStepDetail = React.lazy(() => import('pages/ProcessStep/pages/ProcessStepDetail'));
const ProcessStepEdit = React.lazy(() => import('pages/ProcessStep/pages/ProcessStepEdit'));
const ProcessStepAdd = React.lazy(() => import('pages/ProcessStep/pages/ProcessStepAdd'));

const ProcessStepRoutes = [
    {
        path: '/process-step',
        exact: true,
        name: 'Danh sách bước bảo hành sửa chữa',
        function: 'RS_PROCESSSTEP_VIEW',
        component: ProcessStep,
    },
    {
        path: '/process-step/add',
        exact: true,
        name: 'Thêm mới',
        function: 'RS_PROCESSSTEP_ADD',
        component: ProcessStepAdd,
    },
    {
        path: '/process-step/edit/:id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_PROCESSSTEP_EDIT',
        component: ProcessStepEdit,
    },
    {
        path: '/process-step/detail/:id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_PROCESSSTEP_VIEW',
        component: ProcessStepDetail,
    },
]

export default ProcessStepRoutes
